type PropTypes = {
  className?: string
}

const CursorIcon = ({ className }: PropTypes) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      className={className}
    >
      <path
        fill="currentColor"
        d="m10.985 20.173 2.638-6.57 6.57-2.657.018-1.015L3.788 3.769 9.97 20.173h1.016Zm-.477-2.834L6.342 6.322l11.035 4.146-4.9 1.97-1.97 4.9Z"
      />
    </svg>
  )
}

export default CursorIcon
